module.exports = "/images/image5.jpg?9deca86de0383b6edf131f1a034aa355";